import script from "./whGOnceImg7.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg7.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg7.vue?vue&type=style&index=0&id=267aadfc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267aadfc"]])

export default __exports__